import React, {createContext, useReducer} from "react"
import GAReducer from './googleAnalyticsReducer'

const initialState = {
    pageLoad: false,
    enterSubstep: [],
    exitSubstep: [],
    exitStep: [],
    enterReview: false,
    checkout: false,
    saveDesign: false
}

const GAStore = ({children}) => {
    const [gaState, gaDispatch] = useReducer(GAReducer, initialState)
    return (
        <GAContext.Provider value={[gaState, gaDispatch]}>
            {children}
        </GAContext.Provider>
    )
}

export const GAContext = createContext(initialState)
export default GAStore